export const APP_VERSION = '3.1.0';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: 'LIGHT'
};

export const ADMIN = 'ADMIN';
export const OPERATOR = 'OPERATOR';
export const MANAGER = 'MANAGER';

export const WATCH = 'GUARDIA';
export const NORMAL = 'NORMAL';

export const OPEN = 'OPEN';
export const PLANNED = 'PLANNED';
export const CANCELED = 'CANCELED';
export const COMPLETED = 'COMPLETED';
export const DELAYED = 'DELAYED';
export const PENDING = 'PENDING';
export const WORKING = 'WORKING';
export const OFFICE = 'OFFICE';

export const ACCIDENTS_STATES = [OPEN, CANCELED, COMPLETED];

export const TASKS_STATUS = [OPEN, COMPLETED, PENDING, OFFICE, CANCELED];

export const COMPANY_NAME = 'CONSAMARE S.L.';
export const COMPANY_ID_NUM = 'B11424678';
export const COMPANY_ADDRESS = 'C/ Fco. Garcia de Sola  16';
export const COMPANY_PROVINCE = '(Cádiz)';
export const COMPANY_CITY = 'Cádiz';
export const COMPANY_POSTCODE = '11008';
export const UPDATING_MESSAGE= 'No hay nuevas actualizaciones disponibles';



